app.controller('BrowseProductIndividualDoorSlopingController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const siteHelper = $rootScope.site_helper;

    const navigationIDs = $scope.navigation_ids;

    const productModel = $rootScope.factory.product_door.getModel(navigationIDs);
    $scope.product = productModel.product;

    $scope.alt_product_hrefs = {};

    const documentProductTag = "door_sloping";

    $scope.product_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([navigationIDs.site_range_id, documentProductTag], function (documents) {
        $scope.product_document = documents.length > 0 ? documents[0] : null;
    })


    productModel.apiRequest(function () {
        $scope.product = productModel.product;
    });

    function addDoorHref() {

        const componentObject = $rootScope.service.cache_local_server.getComponentObject(productModel.base_component_id, null, "door");
        if (!$rootScope.service.cache_local_server.isComponentObjectAvailable(componentObject, navigationIDs.site_range_id, navigationIDs.colour_id, navigationIDs.style_id)) {
            return;
        }

        const routeIDs = siteHelper.simpleCloneObject(navigationIDs);
        if (navigationIDs.browse_id === "component") {
            routeIDs.component_id = "door";
        }
        routeIDs.tile_id = "door";
        delete routeIDs.parent_category_id;


        $scope.alt_product_hrefs.door = $rootScope.navigation_manager.createNavigationModel(null, routeIDs).href;
    }

    function addDoorSlopingCalculatorHref() {

        const componentObject = $rootScope.service.cache_local_server.getComponentObject(productModel.base_component_id, null, "door_sloping_calculator");
        if (!$rootScope.service.cache_local_server.isComponentObjectAvailable(componentObject, navigationIDs.site_range_id, navigationIDs.colour_id, navigationIDs.style_id)) {
            return;
        }

        const routeIDs = siteHelper.simpleCloneObject(navigationIDs);
        routeIDs.tile_id = "door_sloping_calculator";
        delete routeIDs.parent_category_id;


        $scope.alt_product_hrefs.calculator = $rootScope.navigation_manager.createNavigationModel(null, routeIDs).href;
    }

    addDoorHref();
    addDoorSlopingCalculatorHref();


    $scope.addToCartHandler = function (validateFormCallback, product) {

        const complexOption = $rootScope.service.option_product.currentComplexOption(product);

        const orderLine = {

            type: product.api_code,

            quantity: product.quantity,
            cost: product.displayPrice(),

            range: product.getSubmitRangeID(),
            site_range: navigationIDs.site_range_id,
            colour: navigationIDs.colour_id,
            style: navigationIDs.style_id,

            height: product.height,
            width: product.width,

            rotate_grain: product.rotate_grain,

            option_id: complexOption.id,

            handle_colour: product.option_term_ids.handle_colour,
            handle_position: product.option_term_ids.handle_position_knebworth,

            midrail: product.option_term_values.midrail ? product.option_term_values.midrail.midrail_height : null,

            left_angle_height: product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_height : null,
            left_angle_width: product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.left_angle_width : null,
            right_angle_height: product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_height : null,
            right_angle_width: product.option_term_values.door_sloping_angle ? product.option_term_values.door_sloping_angle.right_angle_width : null,

            hinge_holes: $rootScope.service.product.collectHingeHoles(product),

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,

            group_name: product.group_name
        };

        const orderBuild = {
            range: orderLine.range,
            colour: orderLine.colour,
            style: orderLine.style,
            lines: [orderLine]
        };


        $rootScope.service.product.addToCart(orderBuild, function (success, messages) {
            if (success) {

                $rootScope.service.product.resetProduct(product);

                product.height = '';
                product.width = '';
                product.left_side_square = false;
                product.right_side_square = false;


                product.rotate_grain = false;

            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        });
    };

}]);